import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import {  useNavigate } from "react-router-dom";

function LoginHistory() {

    const navigate=useNavigate()
    const [referralApi, setreferralApi] = useState([]);
    const [leftreferralApi, setleftreferralApi] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [listPerpage, setlistPerpage] = useState(10);
    const [currentPage2, setcurrentPage2] = useState(1);
    const [listPerpage2, setlistPerpage2] = useState(10);
    const [positionfilter, setpositionfilter] = useState("0");
    const [StatusFilter, setStatusFilter] = useState("1");
    const [allMember, setAllMember] = useState("");
    const [uid,setUid]=useState("")
    const [mail,setmail]=useState("")
  
    const referral_API = async () => {
      try {
        let responceRight = await API?.post("/loginHistory", {
            "UserId":uid,			
            "EmailId":mail	
        });
        console.log("My_Team", responceRight.data.data);
        // setStakingdata(responceRight?.data?.data.records[0])
        responceRight = responceRight.data.data;
        setAllMember(responceRight);
        setleftreferralApi([]);
        let arrayLeft = [];
  
        responceRight.forEach((item, index) => {
          arrayLeft.push({
            sr: index + 1,
            user_id: `${item?.UserId} `,
            email: item?.Email,
            EDate: `${item?.EDate} `,
            Status: `${item?.Status} `,
            password:`${item.Password}`,
            IpAddress:item.IpAddress
          });
  
          setleftreferralApi(arrayLeft);
        });
      } catch (e) {
        console.log("Error While calling Myteam API", e);
      }
    };
  
  
    useEffect(() => {
      referral_API();
    }, [positionfilter,StatusFilter]);
  
    const indexOfLastPost = currentPage * listPerpage;
    const indexOfFirstPage = indexOfLastPost - listPerpage;
    const indexOfLastPost2 = currentPage2 * listPerpage2;
    const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
    const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
    const currentPostleft = leftreferralApi.slice(
      indexOfFirstPage2,
      indexOfLastPost2
    );
  
    var [my_team, set_my_team] = new useState({
      cols: [
        { Header: "S.No.", accessor: "sr" },
        { Header: "User Id", accessor: "user_id" },
        { Header: " Email ", accessor: "email" },
        { Header: " Password ", accessor: "password" },
        { Header: "IP Address", accessor: "IpAddress" },
        { Header: "Date", accessor: "EDate" },
        { Header: "Status ", accessor: "Status" },
      ],
    });
  
  return (
    <div>
      <Navbar />
      <div class="content-page content_page_hit">
        <div class="content">
          <div class="container">
            {/* <-- inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">User Login History</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      action="/Admin/BulkRegistration"
                      method="post"
                      class="ng-pristine in-ip-1 ng-valid"
                    >
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-md-3">
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setUid(e.target.value)}
                              name="uid"
                              placeholder="Search By User Id "
                              type="text"
                              value={uid}
                              maxLength={20}
                            />
                          </div>
                          <div class="col-md-4">
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setmail(e.target.value)}
                              name="uid"
                              placeholder="Search By  Email"
                              type="text"
                              value={mail}
                            />
                          </div>

                          <div class="col-md-3 col-xs-12">
                            <input
                              type="reset"
                              id="btnsearch"
                              formmethod="get"
                              onClick={() => (referral_API(),setcurrentPage2(1))}
                              class="btn btn-lg btn-primary"
                              value="Search"
                            />
                            &nbsp;&nbsp;
                          </div>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: "scroll" }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginHistory